import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AffiliateGridComponent } from './affiliate-grid.component';
import { AuthGuard } from '../../../../core/services/authGuard';

const routes: Routes = [
  {
    path: 'manage/admin/affiliate-grid',
    component: AffiliateGridComponent,
    canActivate: [AuthGuard],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AffiliateGridRoutingModule {}
